import styled, { css } from 'styled-components';

export const ContextMenuContainer = styled.div<{ isOpen: boolean }>`
  width: auto;
  border-radius: 0px 0px 0px 20px;
  position: absolute;
  top: 100%;
  right: 0;
  transition: all 0.5s;
  overflow: hidden;
  z-index: ${({ theme }) => theme.layers.intermediateMediumLayer};
  min-width: 269px;
  max-height: 100vh;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
  background-color: ${({ theme }) => theme.sidebar.background};

  ${({ isOpen }) =>
    !isOpen &&
    css`
      transition: all 0.3s;
      max-height: 0;
    `}
`;

export const ContextMenuBox = styled.div`
  padding: 10px;
  height: 100%;
`;

export const ContextInfoBox = styled.div`
  border-bottom: 1px solid;
  display: flex;
  padding: 10px 20px 18px 6px;
  border-color: ${({ theme }) => theme.grayCC};
  color: ${({ theme }) => theme.contextMenu.color};
`;

export const ContextInfoContainer = styled.div`
  margin-left: 8px;
`;
export const ContextInfoLabel = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 20.08px;
`;
export const ContextInfoSubLabel = styled.div<{ highlighted: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 17.57px;
  ${({ highlighted, theme }) =>
    highlighted &&
    css`
      color: ${theme.contextMenu.active};
    `}
`;

export const ContextItemBox = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  margin-top: 6px;
  padding: 8px 0px 8px 10px;
  path {
    color: ${({ theme }) => theme.contextMenu.active};
    &:hover {
      * {
        color: ${({ theme }) => theme.contextMenu.active};
      }
      & > div svg > path {
        stroke: ${({ theme }) => theme.contextMenu.active};
      }
    }
  }
`;

export const ContextItemLabel = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin-left: 8px;
  user-select: none;
  color: ${({ theme }) => theme.contextMenu.color};
`;

export const VersionContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

export const VersionLabel = styled.div`
  color: ${({ theme }) => theme.grayCC};
`;
